import api from '../api/axiosInstance';

export const repositoryService = {
  getAll: () => api.get('/api/software-repositories'),
};
